import * as React from 'react';

function SvgOcLogo(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 214 40" {...props}>
			<defs>
				<radialGradient
					id="oc-logo_svg__b"
					cx="36.196%"
					cy="34.35%"
					r="78.25%"
					fx="36.196%"
					fy="34.35%"
				>
					<stop offset="0%" stopColor="#1ED460" />
					<stop offset="27%" stopColor="#1ED260" />
					<stop offset="42%" stopColor="#1ECA5E" stopOpacity={0.99} />
					<stop offset="54%" stopColor="#1DBC5B" stopOpacity={0.99} />
					<stop offset="65%" stopColor="#1CA957" stopOpacity={0.98} />
					<stop offset="75%" stopColor="#1B9052" stopOpacity={0.96} />
					<stop offset="83%" stopColor="#1A714C" stopOpacity={0.95} />
					<stop offset="92%" stopColor="#194D44" stopOpacity={0.93} />
					<stop offset="99%" stopColor="#17243C" stopOpacity={0.9} />
					<stop offset="100%" stopColor="#171E3B" stopOpacity={0.9} />
				</radialGradient>
				<linearGradient
					id="oc-logo_svg__a"
					x1="56.161%"
					x2="42.773%"
					y1="13.762%"
					y2="87.539%"
				>
					<stop offset="0%" stopColor="#1ED460" stopOpacity={0.5} />
					<stop offset="27%" stopColor="#1ECE5F" stopOpacity={0.5} />
					<stop offset="45%" stopColor="#1DBB5B" stopOpacity={0.51} />
					<stop offset="61%" stopColor="#1C9C55" stopOpacity={0.53} />
					<stop offset="76%" stopColor="#1A6F4B" stopOpacity={0.56} />
					<stop offset="89%" stopColor="#183540" stopOpacity={0.59} />
					<stop offset="94%" stopColor="#171E3B" stopOpacity={0.6} />
				</linearGradient>
			</defs>
			<g fill="none" fillRule="evenodd">
				<path d="M0 28.571h213.714V40H0z" />
				<g fillRule="nonzero">
					<path
						fill="#FFF"
						d="M55.298 12.092v.011a5.004 5.004 0 014.994 5.017v6.628a5.013 5.013 0 01-4.994 5.017h-13.82V12.092h13.82zm23.301 0v3.744H67.736a2.127 2.127 0 00-1.18.324 1.226 1.226 0 000 2.08c.356.212.766.315 1.18.298h5.33a7.903 7.903 0 013.379.696 4.96 4.96 0 012.456 2.352c.325.651.497 1.368.502 2.095a4.693 4.693 0 01-.487 2.107c-1.013 1.984-2.959 2.977-5.85 2.977h-10.31V25.04h11.001a1.99 1.99 0 001.18-.346c.334-.217.527-.596.506-.994a1.177 1.177 0 00-.506-1.02 1.942 1.942 0 00-1.18-.372h-5.43c-2.75 0-4.626-1.012-5.642-2.977a4.704 4.704 0 01-.51-2.174 4.626 4.626 0 01.51-2.15c.994-1.944 2.888-2.915 5.642-2.915H78.6zm-43.987 0a4.812 4.812 0 013.506 1.466 4.867 4.867 0 011.489 3.562v6.628a5.013 5.013 0 01-4.995 5.017h-13.83V12.092zm-20.73-.004a5.022 5.022 0 015.017 5.032v6.628a5.014 5.014 0 01-5.017 5.017h-8.78a5.002 5.002 0 01-5.016-5.016V17.12a5.01 5.01 0 015.017-5.032zm41.412 3.752H45.223v9.181h10.07c.333.006.652-.129.88-.372.242-.236.377-.562.371-.9v-6.633a1.229 1.229 0 00-.372-.904 1.172 1.172 0 00-.878-.372zm-20.682 0H24.526v9.181h10.086a1.17 1.17 0 00.879-.372h-.012c.249-.233.388-.56.384-.9v-6.633a1.233 1.233 0 00-.372-.904 1.183 1.183 0 00-.879-.372zm-20.73.007h-8.78a1.153 1.153 0 00-.874.372 1.21 1.21 0 00-.372.901v6.628c-.007.34.128.666.372.901.225.243.543.378.875.372h8.775c.333.01.654-.125.879-.372.243-.235.378-.562.372-.9V17.12a1.301 1.301 0 00-.346-.9 1.21 1.21 0 00-.9-.373z"
					/>
					<path
						fill="#1ED460"
						d="M193.947 12.047v3.748h-11.675v2.661h11.258v3.767h-11.258v2.776h11.675v3.77h-15.445V12.047h15.445zm5.628.004v.022h9.144a5.013 5.013 0 014.994 5.017v1.645a4.809 4.809 0 01-1.458 3.514 4.821 4.821 0 01-3.54 1.477h-.554l5.065 5.017h-5.318l-5.017-5.02h-3.294l-.022-.164v5.21h-3.745V12.051h3.745zm-94.071-.004l.004 6.41h8.362v-6.41h3.748V28.77h-3.748v-6.546h-8.351l-.011-.164v.164h-.004v6.546h-3.744V12.047h3.744zm29.439 0v3.748h-11.675v2.661h11.262v3.767h-11.262v2.776h11.675v3.77H119.5V12.047h15.442zm16.16.026c.81 0 1.61.19 2.333.555a3.772 3.772 0 011.76 1.619l-3.148 2.285a.872.872 0 00-.945-.715h-9.268a1.173 1.173 0 00-.878.373c-.245.234-.38.561-.372.9v6.636c-.007.34.127.668.372.904.226.245.546.38.878.373h9.268c.45 0 .96-.35 1.548-1.042l2.776 2.52a7.803 7.803 0 01-1.965 1.547 4.83 4.83 0 01-2.36.715h-9.255a4.8 4.8 0 01-3.517-1.455 4.843 4.843 0 01-1.49-3.562V17.09a5.007 5.007 0 014.995-5.017zm-55.559 0c.812 0 1.612.19 2.338.555a3.803 3.803 0 011.76 1.615l-3.145 2.289a.872.872 0 00-.945-.715h-9.27c-.332-.006-.65.13-.876.373a1.21 1.21 0 00-.372.9v6.636c-.007.34.128.668.372.904.225.244.544.38.875.373h9.27c.47 0 .969-.35 1.545-1.042l2.777 2.52a7.894 7.894 0 01-1.969 1.547 4.833 4.833 0 01-2.36.715h-9.267a5.013 5.013 0 01-4.994-5.017V17.09a5.013 5.013 0 014.994-5.017zm113.175 3.744h-9.144v4.161h9.148a1.257 1.257 0 001.246-1.246V17.09a1.214 1.214 0 00-.372-.9 1.164 1.164 0 00-.878-.373z"
					/>
					<g transform="translate(157.3 .134)">
						<path
							fill="#1ED460"
							d="M25.36 5.33L3.77 28.602 0 28.605V11.917h3.752v11.362L25.338 5.307z"
						/>
						<path
							fill="url(#oc-logo_svg__a)"
							d="M3.752 11.917v11.355A2.316 2.316 0 01.03 21.728v-9.811h3.722z"
						/>
						<path
							fill="#1ED460"
							d="M19.32 28.605h-5.323l-2.46-2.367-1.287-1.235 2.616-2.821 1.265 1.261z"
						/>
						<circle
							cx={28.255}
							cy={2.319}
							r={2.319}
							fill="url(#oc-logo_svg__b)"
						/>
					</g>
				</g>
			</g>
		</svg>
	);
}

export default SvgOcLogo;
